export default "__VITE_ASSET__DtvN2iHG__"